module.exports = __webpack_public_path__ + "img/tlc.52de13ee.png";